/**
 * This is the tag when you need it to be a link.
 * Clicks bring you to the category page.
 */

import { Link } from "react-router-dom";

import { nFormatter } from "utils/parseNumber";
import { ITag } from "services/types";
import { routes } from "routes";

import "./styles.scss";

export const TagLink = (props: {
  tag: ITag;
  counts: boolean;
}): JSX.Element => {
  return (
    <Link to={routes.singleTag(props.tag.name)} className="tagItem" title={props.tag.name}>
      {props.tag.name}

      {props.counts && (
        <span className="count">{nFormatter(props.tag.count)}</span>
      )}
    </Link>
  );
};
